import { v4 as uuid } from 'uuid';
import { Directive, ElementRef } from '@angular/core';
import { $Element, $ } from '../utils/element';

@Directive({ selector: '[skl-scrolling-edges]' })
export class ScrollingEdgesDirective {
    private mousemoveEventName = `mousemove.scrolling-edges.${uuid()}`;
    private mouseupEventName = `mouseup.scrolling-edges.${uuid()}`;
    private mousedownEventName = `mousedown.scrolling-edges.${uuid()}`;

    private scrollMargin = 50;
    private mainBarHeight = 52;
    private intervalTick = 2;

    private $element: $Element;
    private $document = $(document);
    private intervalScrollingHandler?: ReturnType<typeof setTimeout>;

    public constructor(readonly elRef: ElementRef) {
        this.$element = $(elRef.nativeElement);
    }

    protected ngOnInit(): void {
        this.$document.on(this.mousedownEventName, clickEvent => {
            if (!clickEvent) return;
            const target = $(<any>clickEvent.target);
            const tile = target.hasClass('tile') ? target : target.findParent('.tile');
            if (tile) {
                const maxHeight = this.$element.find('.dashboard__tiles').height();
                this.$document.on(this.mousemoveEventName, moveEvent => {
                    clearInterval(this.intervalScrollingHandler);
                    // going up
                    if ((<any>moveEvent).clientY < (this.scrollMargin + this.mainBarHeight)) {
                        this.intervalScrollingHandler = setInterval(() => {
                            this.$element.setScrollTop(this.$element.getScrollTop() - this.intervalTick);
                        }, 0);
                    }
                    // going down
                    if (((<any>moveEvent).clientY > (window.innerHeight - this.scrollMargin)) &&
                        (this.$element.getScrollTop() + this.intervalTick < maxHeight)) {
                        this.intervalScrollingHandler = setInterval(() => {
                            this.$element.setScrollTop(this.$element.getScrollTop() + this.intervalTick);
                        }, 0);
                    }
                });
            }

            this.$document.on(this.mouseupEventName, () => {
                clearInterval(this.intervalScrollingHandler);
                this.$document.off(this.mousemoveEventName);
                this.$document.off(this.mouseupEventName);
            });
        });
    }

    public ngOnDestroy() {
        clearInterval(this.intervalScrollingHandler);
        this.$document.off(this.mousemoveEventName);
        this.$document.off(this.mouseupEventName);
        this.$document.off(this.mousedownEventName);
    }
}
